module.exports = __webpack_public_path__ + "img/business-explore.7baf1afe.jpg";